const WORKSPACE_GROUPS = {
    MAIN: 'Основное',
    REQUESTS: 'Заявки по направлениям',
    PRODUCTION: 'Производство',
    STRUCTURE: 'Структура',
    ANALYTICS: 'Аналитика'
};

export const DEFAULT_WORKSPACE_KEY = 'shift_report';

export const WORKSPACE_REGISTRY = Object.freeze([
    {
        key: 'shift_report',
        label: 'Сдать отчёт по смене',
        shortLabel: 'Смена',
        path: '/shift-report-master',
        icon: 'fas fa-flag-checkered',
        group: WORKSPACE_GROUPS.MAIN
    },
    {
        key: 'objects',
        label: 'Строительные объекты',
        shortLabel: 'Объекты',
        path: '/objects',
        icon: 'fas fa-city',
        group: WORKSPACE_GROUPS.MAIN
    },
    {
        key: 'reports',
        label: 'Отчёты по сменам',
        shortLabel: 'Отчёты',
        path: '/reports',
        icon: 'fas fa-clipboard-list',
        group: WORKSPACE_GROUPS.MAIN
    },
    {
        key: 'timesheets',
        label: 'Табели',
        shortLabel: 'Табели',
        path: '/timesheets',
        icon: 'fas fa-calendar-check',
        group: WORKSPACE_GROUPS.MAIN
    },
    {
        key: 'requests_materials',
        label: 'Снабжение',
        shortLabel: 'Снабжение',
        path: '/requests?tab=requires_action&request_type_id=category:materials',
        icon: 'fas fa-boxes',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'requests_it',
        label: 'ИТ-поддержка',
        shortLabel: 'ИТ',
        path: '/requests?tab=requires_action&request_type_id=category:it',
        icon: 'fas fa-laptop',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'requests_finance',
        label: 'Бухгалтерия',
        shortLabel: 'Финансы',
        path: '/requests?tab=requires_action&request_type_id=category:finance',
        icon: 'fas fa-file-invoice-dollar',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'requests_fuel_cards',
        label: 'Заявки по топливным картам',
        shortLabel: 'Топливо',
        path: '/requests?tab=requires_action&request_type_id=category:fuelCards',
        icon: 'fas fa-gas-pump',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'requests_mechanics',
        label: 'Заявки механикам',
        shortLabel: 'Механики',
        path: '/requests?tab=requires_action&request_type_id=category:mechanics',
        icon: 'fas fa-tools',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'requests_admin',
        label: 'Административные',
        shortLabel: 'АХО',
        path: '/requests?tab=requires_action&request_type_id=category:admin',
        icon: 'fas fa-building',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'requests_hr',
        label: 'Кадры',
        shortLabel: 'Кадры',
        path: '/requests?tab=requires_action&request_type_id=category:hr',
        icon: 'fas fa-users',
        group: WORKSPACE_GROUPS.REQUESTS
    },
    {
        key: 'completed_works',
        label: 'Выполненные работы',
        shortLabel: 'Работы',
        path: '/completed-works',
        icon: 'fas fa-calendar-check',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'work_groups',
        label: 'Группы работ',
        shortLabel: 'Группы',
        path: '/work-groups',
        icon: 'fas fa-layer-group',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'work_types',
        label: 'Виды работ',
        shortLabel: 'Виды работ',
        path: '/work-types',
        icon: 'fas fa-tools',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'material_using',
        label: 'Использование материалов по договору',
        shortLabel: 'Расход',
        path: '/material-using',
        icon: 'fas fa-tasks',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'materials',
        label: 'Справочник материалов',
        shortLabel: 'Материалы',
        path: '/materials',
        icon: 'fas fa-list-ol',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'mechanic_assets',
        label: 'Справочник техники',
        shortLabel: 'Механики',
        path: '/mechanic-assets',
        icon: 'fas fa-tools',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'fuel_cards',
        label: 'Топливные карты',
        shortLabel: 'Топливо',
        path: '/fuel-cards',
        icon: 'fas fa-credit-card',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'fuel_limits',
        label: 'Лимиты по топливу',
        shortLabel: 'Лимиты',
        path: '/fuel-limits',
        icon: 'fas fa-gas-pump',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'used_fuels',
        label: 'Израсходованное топливо',
        shortLabel: 'Расход топлива',
        path: '/used-fuels',
        icon: 'fas fa-truck-pickup',
        group: WORKSPACE_GROUPS.PRODUCTION
    },
    {
        key: 'employees',
        label: 'Сотрудники',
        shortLabel: 'Сотрудники',
        path: '/employees',
        icon: 'fas fa-address-book',
        group: WORKSPACE_GROUPS.STRUCTURE
    },
    {
        key: 'accounts',
        label: 'Учётные записи',
        shortLabel: 'Учётные записи',
        path: '/users',
        icon: 'fas fa-user-lock',
        group: WORKSPACE_GROUPS.STRUCTURE
    },
    {
        key: 'employees_workforce',
        label: 'Распределение сотрудников',
        shortLabel: 'Распределение',
        path: '/employees/workforce',
        icon: 'fas fa-people-carry',
        group: WORKSPACE_GROUPS.STRUCTURE
    },
    {
        key: 'gallery',
        label: 'Галерея',
        shortLabel: 'Галерея',
        path: '/gallery',
        icon: 'fas fa-image',
        group: WORKSPACE_GROUPS.ANALYTICS
    },
    {
        key: 'charts',
        label: 'Графики',
        shortLabel: 'Графики',
        path: '/charts',
        icon: 'fas fa-chart-bar',
        group: WORKSPACE_GROUPS.ANALYTICS
    }
]);

const WORKSPACE_BY_KEY = WORKSPACE_REGISTRY.reduce((result, workspace) => {
    result[workspace.key] = workspace;
    return result;
}, {});

function safeCan(vm, action, subject) {
    if (!vm || typeof vm.$can !== 'function') {
        return false;
    }
    try {
        return vm.$can(action, subject) === true;
    } catch (error) {
        return false;
    }
}

function isAuthorized(vm) {
    return Boolean(
        vm &&
        vm.$store &&
        vm.$store.getters &&
        vm.$store.getters.isAuthorized
    );
}

function getState(vm) {
    return vm && vm.$store && vm.$store.state ? vm.$store.state : {};
}

function canOpenObjects(vm) {
    const state = getState(vm);
    const settings = state.objectCards && state.objectCards.accessSettings
        ? state.objectCards.accessSettings
        : {};
    return settings.can_list === true ||
        settings.can_access_preparations === true ||
        settings.can_read === true ||
        settings.can_create === true ||
        settings.can_update === true ||
        settings.can_delete === true ||
        settings.can_manage_access === true ||
        safeCan(vm, 'manage', 'all');
}

function canOpenEmployeeRegistry(vm) {
    const store = vm && vm.$store;
    const settings = getState(vm).employeeDirectorySettings || {};
    const getters = store && store.getters ? store.getters : {};
    return settings.can_employee_directory === true || settings.can_employee_registry === true ||
        getters.isAdmin === true ||
        safeCan(vm, 'manage', 'all');
}

function canOpenAccounts(vm) {
    const settings = getState(vm).employeeDirectorySettings || {};
    return settings.can_list === true ||
        Boolean(vm && vm.$store && vm.$store.getters && vm.$store.getters.isAdmin === true);
}

function canOpenEmployeesWorkforce(vm) {
    const settings = getState(vm).employeeDirectorySettings || {};
    return settings.can_board === true || safeCan(vm, 'manage', 'all');
}

function canOpenEmployeeSettings(vm) {
    const settings = getState(vm).employeeDirectorySettings || {};
    return settings.can_employee_settings === true || safeCan(vm, 'manage', 'all');
}

function canOpenFuelLimits(vm) {
    if (safeCan(vm, 'read', 'fuelLimits')) {
        return true;
    }
    const store = vm && vm.$store;
    const currentUser = store && store.getters ? store.getters.currentUser : null;
    const currentUserId = currentUser && currentUser.userId
        ? Number(currentUser.userId)
        : null;
    const processes = Array.isArray(getState(vm).objectsInProcess)
        ? getState(vm).objectsInProcess
        : [];
    return Boolean(
        currentUserId &&
        processes.some(process => Number(process.curator_id) === currentUserId)
    );
}

const WORKSPACE_ACCESS = {
    shift_report: vm => safeCan(vm, 'read', 'shiftReportMaster'),
    timesheets: isAuthorized,
    objects: canOpenObjects,
    reports: vm => safeCan(vm, 'read', 'reports'),
    requests_materials: isAuthorized,
    requests_it: isAuthorized,
    requests_finance: isAuthorized,
    requests_fuel_cards: isAuthorized,
    requests_mechanics: isAuthorized,
    requests_admin: isAuthorized,
    requests_hr: isAuthorized,
    completed_works: vm => safeCan(vm, 'read', 'objectsInProcess') &&
        safeCan(vm, 'read', 'completedWorks'),
    work_groups: vm => safeCan(vm, 'read', 'objectsInProcess') &&
        safeCan(vm, 'read', 'workGroups'),
    work_types: vm => safeCan(vm, 'read', 'objectsInProcess') &&
        safeCan(vm, 'read', 'workTypes'),
    material_using: vm => safeCan(vm, 'read', 'materials') &&
        safeCan(vm, 'read', 'materialUsing'),
    materials: vm => safeCan(vm, 'read', 'materials'),
    mechanic_assets: vm => safeCan(vm, 'read', 'mechanicAssets'),
    fuel_cards: isAuthorized,
    fuel_limits: canOpenFuelLimits,
    used_fuels: vm => safeCan(vm, 'read', 'usedFuels'),
    employees: canOpenEmployeeRegistry,
    accounts: canOpenAccounts,
    employees_workforce: canOpenEmployeesWorkforce,
    gallery: vm => safeCan(vm, 'read', 'gallery'),
    charts: vm => safeCan(vm, 'read', 'chartsPage')
};

const MODERN_MENU_LABELS = {
    shift_report: 'Сдать отчёт',
    reports: 'Все отчёты',
    completed_works: 'Выполненные',
    material_using: 'Использование по договору',
    materials: 'Справочник',
    fuel_cards: 'Карты',
    fuel_limits: 'Лимиты',
    used_fuels: 'Расход'
};

const MODERN_AUXILIARY_LINKS = {
    delete_shift_report: {
        key: 'delete_shift_report',
        label: 'Аннулирование',
        path: '/requests/delete-shift-report',
        icon: 'fas fa-trash-alt',
        canOpen: isAuthorized
    },
    material_groups: {
        key: 'material_groups',
        label: 'Группы',
        path: '/material-groups',
        icon: 'fas fa-layer-group',
        canOpen: vm => safeCan(vm, 'read', 'materials') &&
            safeCan(vm, 'read', 'materialGroups')
    },
    user_groups: {
        key: 'user_groups',
        label: 'Группы сотрудников',
        path: '/user-groups',
        icon: 'fas fa-user-tag',
        canOpen: vm => safeCan(vm, 'read', 'usersGroups')
    },
    departments: {
        key: 'departments',
        label: 'Отделы',
        path: '/departments',
        icon: 'fas fa-building',
        canOpen: vm => safeCan(vm, 'read', 'users')
    },
    reports_management: {
        key: 'reports_management',
        label: 'Отчёты и уведомления',
        path: '/reports-management',
        icon: 'fas fa-bell',
        canOpen: vm => safeCan(vm, 'read', 'reports-management')
    },
    alerts_management: {
        key: 'alerts_management',
        label: 'Уведомления о действиях',
        path: '/alerts-management',
        icon: 'fas fa-bell',
        canOpen: vm => safeCan(vm, 'read', 'alerts-management')
    },
    employees_settings: {
        key: 'employees_settings',
        label: 'Модуль «Сотрудники»',
        path: '/employees/workforce/settings',
        icon: 'fas fa-users-cog',
        canOpen: canOpenEmployeeSettings
    },
    timesheet_settings: {
        key: 'timesheet_settings',
        label: 'Модуль «Табели»',
        path: '/timesheets/settings',
        icon: 'fas fa-calendar-alt',
        canOpen: vm => Boolean(vm && vm.$store && vm.$store.getters && vm.$store.getters.isAdmin)
    }
};

const MODERN_NAVIGATION_BLUEPRINT = [
    {
        key: 'request_directions',
        label: 'Заявки по направлениям',
        icon: 'fas fa-clipboard-list',
        items: [
            'requests_materials',
            'requests_it',
            'requests_finance',
            'requests_fuel_cards',
            'requests_mechanics',
            'requests_admin',
            'requests_hr'
        ]
    },
    {
        key: 'production',
        label: 'Производство',
        icon: 'fas fa-hard-hat',
        items: [
            'objects',
            'timesheets',
            {
                key: 'shift_reports',
                label: 'Отчёты по сменам',
                icon: 'fas fa-clipboard-list',
                items: ['shift_report', 'reports', 'delete_shift_report']
            },
            {
                key: 'works',
                label: 'Работы',
                icon: 'fas fa-tools',
                items: ['completed_works', 'work_groups', 'work_types']
            },
            {
                key: 'materials_group',
                label: 'Материалы',
                icon: 'fas fa-boxes',
                items: ['material_using', 'materials', 'material_groups']
            },
            'mechanic_assets',
            {
                key: 'fuel',
                label: 'Топливо',
                icon: 'fas fa-gas-pump',
                items: ['fuel_cards', 'fuel_limits', 'used_fuels']
            }
        ]
    },
    {
        key: 'structure',
        label: 'Люди',
        icon: 'fas fa-users',
        items: ['employees', 'accounts', 'employees_workforce', 'user_groups', 'departments']
    },
    {
        key: 'analytics',
        label: 'Аналитика',
        icon: 'fas fa-chart-line',
        items: ['charts', 'gallery']
    },
    {
        key: 'settings',
        label: 'Настройки',
        icon: 'fas fa-cog',
        items: ['employees_settings', 'timesheet_settings', 'reports_management', 'alerts_management']
    }
];

function modernLeafByKey(vm, key) {
    const workspace = WORKSPACE_BY_KEY[key];
    if (workspace) {
        const accessCheck = WORKSPACE_ACCESS[key];
        if (typeof accessCheck !== 'function' || !accessCheck(vm)) {
            return null;
        }
        return Object.assign({}, workspace, {
            kind: 'link',
            label: MODERN_MENU_LABELS[key] || workspace.label
        });
    }

    const auxiliary = MODERN_AUXILIARY_LINKS[key];
    if (!auxiliary || !auxiliary.canOpen(vm)) {
        return null;
    }
    return Object.assign({}, auxiliary, {kind: 'link'});
}

function modernNodeFromBlueprint(vm, blueprint, excludedWorkspaceKey) {
    if (typeof blueprint === 'string') {
        if (blueprint === excludedWorkspaceKey) {
            return null;
        }
        return modernLeafByKey(vm, blueprint);
    }

    const items = blueprint.items
        .map(item => modernNodeFromBlueprint(vm, item, excludedWorkspaceKey))
        .filter(Boolean);
    if (!items.length) {
        return null;
    }
    return {
        key: blueprint.key,
        label: blueprint.label,
        icon: blueprint.icon,
        kind: 'group',
        items
    };
}

/**
 * Возвращает зарегистрированный рабочий раздел.
 * Неизвестный ключ никогда не даёт undefined: используется shift_report
 * (или явно переданный валидный fallbackKey).
 */
export function getWorkspaceByKey(key, fallbackKey = DEFAULT_WORKSPACE_KEY) {
    const normalizedKey = typeof key === 'string' ? key.trim() : '';
    if (WORKSPACE_BY_KEY[normalizedKey]) {
        return WORKSPACE_BY_KEY[normalizedKey];
    }
    return WORKSPACE_BY_KEY[fallbackKey] || WORKSPACE_REGISTRY[0];
}

/**
 * Фильтрует каталог по доступам CASL и настройкам разделов.
 */
export function getAvailableWorkspaces(vm) {
    return WORKSPACE_REGISTRY.filter(workspace => {
        const accessCheck = WORKSPACE_ACCESS[workspace.key];
        return typeof accessCheck === 'function' && accessCheck(vm);
    });
}

/**
 * Единое двухуровневое дерево только для современного интерфейса.
 * excludedWorkspaceKey убирает выбранную четвёртую вкладку из desktop sidebar,
 * но не из каталога «Ещё».
 */
export function getModernNavigationSections(vm, excludedWorkspaceKey = null) {
    return MODERN_NAVIGATION_BLUEPRINT
        .map(section => modernNodeFromBlueprint(vm, section, excludedWorkspaceKey))
        .filter(Boolean);
}
